import { z } from 'zod';

export const NotificationChannelSchema = z.enum(['email', 'whatsapp']);
export type NotificationChannel = z.infer<typeof NotificationChannelSchema>;

export const NotificationStatusSchema = z.enum(['queued', 'sent', 'failed', 'skipped', 'cooldown']);
export type NotificationStatus = z.infer<typeof NotificationStatusSchema>;

export const NotificationLogSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  loanId: z.string().nullable().optional(),
  workflowInstanceId: z.string().nullable().optional(),
  stepKey: z.string().nullable().optional(),
  channel: NotificationChannelSchema,
  recipient: z.string(),
  subject: z.string().nullable().optional(),
  message: z.string(),
  status: NotificationStatusSchema,
  providerResponse: z.string().nullable().optional(),
  error: z.string().nullable().optional(),
  createdAt: z.string().datetime(),
});
export type NotificationLog = z.infer<typeof NotificationLogSchema>;
